export const ADMIN = {
    loginPage: "admin-login-page",
    googleLoginBtn: "admin-google-login-btn",
    logoutBtn: "admin-logout-btn",
    listPage: "admin-list-page",
    listEmpty: "admin-list-empty",
    listRow: "admin-list-row",
    listSearch: "admin-list-search",
    listFilterAll: "admin-list-filter-all",
    listFilterReversal: "admin-list-filter-reversal",
    listFilterLongevity: "admin-list-filter-longevity",
    detailDrawer: "admin-detail-drawer",
    detailClose: "admin-detail-close",
    detailMailto: "admin-detail-mailto",
    detailWhatsapp: "admin-detail-whatsapp",
    authCallbackProcessing: "admin-auth-callback-processing",
};
